import { Component, computed, input, linkedSignal } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  isNavGroup,
  isNavLinkItem,
  isNavNoDestinationItem,
  isNavRouteItem,
  NavItem,
} from '../../../types/navigation.types';
import { BaseComponent } from '../../base/base.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'immo-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrl: './navigation-item.component.css',
  imports: [
    RouterLink,
    MatIconModule,
    MatRippleModule,
    MatTooltipModule,
    TranslateModule,
    CommonModule,
  ],
  host: {
    '[attr.data-active]': 'item().isActive?.()',
  },
})
export class NavigationItemComponent<T extends NavItem> extends BaseComponent {
  // -----------------------------------------------------------------------------------------------------
  // @ INPUTS
  // -----------------------------------------------------------------------------------------------------

  readonly item = input.required<T>();

  readonly isSidebarExpanded = input.required<boolean>({
    alias: 'isExpanded',
  });

  readonly withIcon = input<boolean>(true);

  // -----------------------------------------------------------------------------------------------------
  // @ COMPUTED
  // -----------------------------------------------------------------------------------------------------

  readonly isRoute = computed<boolean>(() => isNavRouteItem(this.item()));

  readonly hasGroups = computed<boolean>(() => isNavGroup(this.item()));

  readonly isNoDestination = computed<boolean>(() => isNavNoDestinationItem(this.item()));

  readonly isLink = computed<boolean>(() => isNavLinkItem(this.item()));

  readonly isExpanded = linkedSignal<boolean>(() =>
    this.hasGroups() ? (this.item().expandedByDefault ?? false) : false,
  );
}
